import { useTranslation } from 'hooks/useLingUI';
import styles from './CarrelloFooterAvvenimentoInfoRow.module.scss';

export type CarrelloFooterAvvenimentoInfoRowProps = {
  competitors: string;
  scommessa: {
    tipoScommessaTrKey?: string;
    tipoScommessa?: string;
    esito?: string;
    quota: number;
  };
  hasOnlyHorizontalPadding?: boolean;
};

export const CarrelloFooterAvvenimentoInfoRow = ({
  competitors,
  scommessa,
  hasOnlyHorizontalPadding,
}: CarrelloFooterAvvenimentoInfoRowProps) => {
  const { t } = useTranslation();
  const { tipoScommessa, esito, quota, tipoScommessaTrKey } = scommessa;
  return (
    <div className={`${styles.container} ${hasOnlyHorizontalPadding ? styles.hasOnlyHorizontalPadding : ''}`}>
      <p className={styles.competitors}>{competitors}</p>
      <div className={styles.textWrapper}>
        <p className={styles.paragraph} suppressHydrationWarning>
          {t(tipoScommessaTrKey, tipoScommessa)}: <span>{esito}</span>
        </p>
        <span className={styles.label}>{quota}</span>
      </div>
    </div>
  );
};
